import React from "react";
import ReactPlayer from "react-player";

import { Stack } from "@origin-digital/ods-core";
import { Accordion, List, ListItem, Text } from "@origin-digital/style-guide";

import { AspectRatio } from "src/components/AspectRatio";

type Transcript = string | string[];

interface IContent {
  heading: string;
  url: string;
  transcript: Transcript[];
}

export const Transcript: React.FC<{ content: IContent }> = ({ content }) => (
  <Accordion label={content.heading} condensed borderTop>
    <Stack space="xsmall">
      {content.transcript.map((text, idx) => {
        if (typeof text === "string") {
          return (
            <Text key={`text-${idx}`} markdown>
              {text}
            </Text>
          );
        }

        return (
          <List type="ordered" key={`list-${idx}`}>
            {text.map((item, listIdx) => (
              <ListItem key={`list-item-${idx}-${listIdx}`}>{item}</ListItem>
            ))}
          </List>
        );
      })}
    </Stack>
  </Accordion>
);

export const Video: React.FC<{ content: IContent }> = ({ content }) => (
  <AspectRatio>
    <ReactPlayer url={content.url} width="100%" height="100%" />
  </AspectRatio>
);
